class QuickAddCard extends HTMLElement {
  constructor() {
    super();
    // Init component
    this.attachShadow({ mode: "open" });
    let plusIcon = document.createElement("div");
    plusIcon.classList.add("quick-add_card-plus");
    plusIcon.innerHTML = "+";
    this.parentNode.parentElement.appendChild(plusIcon);
    this.shadowRoot.innerHTML = `
      <style>
        .hidden {
          display: none;
        }
        .option {
          cursor: pointer;
          padding: 5px;
          border: 1px solid #fff;
          margin: 5px;
          display: inline-block;
          background-color: #fff;
          color: #000;
          transition: all .2s ease;
        }
          .option.color.false .circle-color-swatch::after {
        content: '';
        display: block;
        height: 2px;
        width: 100%;
        background-color: rgb(18,18,18);
        transform: rotate(45deg);
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
      }
      .option.color.false .circle-color-swatch {
        position: relative;
        webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
        opacity: 0.5;
        border-color:rgb(18,18,18);
      }

        @media screen and (min-width: 1050px) {
          .option.color {
            margin-bottom: 31px;
          }
        }
        @media screen and (max-width: 1050px){
          .option {
            margin: 1px;
            padding: 2px;
          }
        }
        #options-size .option:hover {
          border: 1px solid #00000096;
          transition: all .2s ease;
        }
        .option.selected {
          background-color: #000;
          color: #fff;
        }
        #options-size,
        #options-color {
          background: #fff;
        }
        #options-size .option {
          width: 100%;
          max-width: max-content;
          min-width: 20px;
        }
        .circle-color-swatch {
          display: block;
          width: 100%;
          min-width: 26px;
          min-height: 26px;
          border-radius: 100%;
          aspect-ratio: 1 / 1;
          box-shadow: 2px 3px 5px #00000059;
          transition: all .2s ease;
          border: 1px solid #fff;
        }
        .circle-color-swatch:hover {
          transition: all .2s ease;
          border: 1px solid #00000096;
          box-shadow: none;
        }
        .color-swatch-tooltip {
          visibility: hidden;
          opacity: 0;
          position: absolute;
        }
        @media screen and (min-width: 1050px) {
          .color-swatch-tooltip {
            z-index: 15;
            position: absolute;
            visibility: visible;
            background: #fff;
            bottom: 5px;
            right: 0;
            padding: 5px 3px 3px 3px;
            left: 0;
            max-width: max-content;
            margin: 0 auto;
            opacity: 0;
            transition: all .5s ease;
            box-shadow: 2px 3px 5px #00000059;
          }
          .option.color:hover .color-swatch-tooltip {
            opacity: 1;
            transition all .4s ease;
          }
        }

        button {
          margin-top: 15px;
          width: 100%;
          padding: 10px;
          background-color: #ffffffe3;
          color: #000;
          border: none;
          cursor: pointer;
          border: 1px solid #fff;
          box-shadow: 2px 3px 5px #00000059;
        }
        #selection-text {
          margin: 0;
          background: #fff;
          padding: 5px;
        }
        #back-btn {
          position: absolute;
          left: 1%;
          background: transparent;
          border: none;
          font-size: 20px;
          cursor: pointer;
          max-width: max-content;
          margin: auto;
          box-shadow: none;
          bottom: 50%;
        }
        #back-btn svg {
          color: black;
          fill: black;
          width: 16px;
          height: 16px;
          rotate: 180deg;
        }
        @media screen and (max-width: 1350px) {
          #back-btn {
            display: none;
          }
        }
        .visually-hidden {
          position: absolute !important;
          overflow: hidden;
          width: 1px;
          height: 1px;
          margin: -1px;
          padding: 0;
          border: 0;
          clip: rect(0 0 0 0);
          word-wrap: normal !important;
        }

      </style>

      <div>
       <p id="selection-text" class="hidden"></p>
        <button id="back-btn" class="hidden">
          <svg
          viewBox="0 0 14 10"
          fill="none"
          aria-hidden="true"
          focusable="false"
          class="icon icon-arrow"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor">
        </svg>

        </button>
        <button id="add-to-cart-btn" class="visually-hidden">Add to Cart</button>
        <div id="options-size" class="hidden">
          <!-- Size options will be populated here -->
        </div>
        <div id="options-color" class="hidden">
          <!-- Color options will be populated here -->
        </div>
      </div>
    `;

    this.productUrl = this.getAttribute("product-url");
    this.addToCartBtn = this.shadowRoot.querySelector("#add-to-cart-btn");
    this.selectionText = this.shadowRoot.querySelector("#selection-text");
    this.backBtn = this.shadowRoot.querySelector("#back-btn");
    this.optionsSizeContainer = this.shadowRoot.querySelector("#options-size");
    this.optionsColorContainer =
      this.shadowRoot.querySelector("#options-color");
    this.plusIconCta = this.parentNode.parentElement.querySelector(
      ".quick-add_card-plus"
    );
    this.selectedSize = null;
    this.selectedColor = null;
    this.productData = null;
    this.selectionStep = 0;
    this.isProcessingAdd = false;
  }

  connectedCallback() {
    window.addEventListener("load", () => {
      this.plusIconCta.addEventListener("click", () => this.fetchProductData());
      this.plusIconCta.addEventListener("pointerdown", () => {
        this.plusIconCta.style.transform = "rotate(180deg)";
        if (this.addToCartBtn) {
          this.triggerOptions();
        } else {
          console.error(
            "Error: addToCartBtn is not available. triggerOptions() cannot be executed",
            {
              addToCartBtn: this.addToCartBtn,
              shadowRoot: this.shadowRoot,
              element: this,
            }
          );
        }
      });
      this.backBtn.addEventListener("click", () => this.goBack());
    });
  }

  fetchProductData() {
    if (this.isProcessingAdd) {
      return;
    }
    this.isProcessingAdd = true;
    // Get product info
    fetch(`${this.productUrl}.js`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        // Check stock availability
        if (data.available == false) {
          this.style.opacity = "1";
          this.addToCartBtn.innerHTML = "Sold Out";
          return;
        }
        this.productData = data;

        // Avoid errors with variants order and naming 'SIZE' 'Size' 'size'
        this.sizeIndex = this.productData.options.findIndex(
          (option) => option.name.toLowerCase() === "size"
        );
        this.colorIndex = this.productData.options.findIndex(
          (option) => option.name.toLowerCase() === "color"
        );

        const hasSizeOptions = this.sizeIndex !== -1;
        const hasColorOptions = this.colorIndex !== -1;

        // Fill quick add step options
        if (hasSizeOptions) {
          this.populateSizeOptions();
          this.updateSelectionText("Size");
        } else if (hasColorOptions) {
          this.populateColorOptions();
          this.updateSelectionText("Color");
        } else {
          this.addToCart(this.productData.variants[0].id);
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        this.isProcessingAdd = false;
      });
  }

  triggerOptions() {
    this.addToCartBtn.classList.add("hidden");
    this.style.opacity = "1";
    this.style.bottom = "0";
    this.addToCartBtn.style.display = "none";
    setTimeout(() => {
      this.addToCartBtn.style.display = "";
    }, 0);
  }

  updateSelectionText(optionType) {
    // Select 'Size' 'Color' html
    this.selectionText.textContent = `Select ${optionType}`;
    this.selectionText.classList.remove("hidden");
  }

  populateSizeOptions() {
    if (!this.productData || !this.productData.variants) {
      console.error("Product data is missing or incomplete.");
      return;
    }

    this.addToCartBtn.classList.add("hidden");
    this.optionsSizeContainer.classList.remove("hidden");
    this.backBtn.classList.remove("hidden");

    const uniqueSizes = [
      ...new Set(
        this.productData.variants.map(
          (variant) => variant.options[this.sizeIndex]
        )
      ),
    ];

    this.optionsSizeContainer.innerHTML = uniqueSizes
      .map((size) => {
        return `<span class="option" data-size="${size}">${size}</span>`;
      })
      .join("");

    this.shadowRoot.querySelectorAll(".option[data-size]").forEach((option) => {
      option.addEventListener("click", (event) => this.selectSize(event));
    });
  }

  selectSize(event) {
    this.selectedSize = event.target.getAttribute("data-size");
    this.shadowRoot.querySelectorAll(".option[data-size]").forEach((option) => {
      option.classList.remove("selected");
    });
    event.target.classList.add("selected");
    this.optionsSizeContainer.classList.add("hidden");
    this.populateColorOptions();
  }

  populateColorOptions() {
    if (!this.productData || !this.productData.variants) {
      console.error("Product data is missing or incomplete.");
      return;
    }

    let filteredVariants = this.productData.variants;
    this.addToCartBtn.classList.add("hidden");
    this.backBtn.classList.remove("hidden");
    this.updateSelectionText("Color");

    if (this.sizeIndex !== -1) {
      filteredVariants = filteredVariants.filter(
        (variant) => variant.options[this.sizeIndex] === this.selectedSize
      );
    }

    const uniqueColors = [
      ...new Set(
        filteredVariants.map((variant) => variant.options[this.colorIndex])
      ),
    ];

    if (uniqueColors.length === 1 && !uniqueColors[0]) {
      this.addToCart(filteredVariants[0].id);
      return;
    }

    const colorOptionsWrapper = document.createElement("div");
    colorOptionsWrapper.classList.add("color-options-wrapper");
    this.optionsColorContainer.appendChild(colorOptionsWrapper);
    this.optionsColorContainer.classList.remove("hidden");
    this.optionsColorContainer.innerHTML = uniqueColors
      .map((color, index) => {
        const variantDataElement = document.querySelector(
          `.variant-data[data-color-name="${color}"]`
        );

        // Verificar si existe una URL de imagen, si no, usar el color hexadecimal
        const backgroundUrl = variantDataElement.getAttribute("data-image-url");
        const backgroundHex = variantDataElement.getAttribute("data-color-hex");
        const backgroundStyle = backgroundUrl
          ? `background:url(${backgroundUrl})`
          : `background-color:${backgroundHex ?? color}`;

        return `
         <span class="option color ${this.productData.variants[index].available}" data-color="${color}">
          <span class="circle-color-swatch" style="${backgroundStyle};" data-color="${color}" aria-label="Select ${color} color"></span>
          <span class="color-swatch-tooltip" aria-hidden="true" data-color="${color}">${color}</span>
        </span>`;
      })
      .join("");

    this.shadowRoot
      .querySelectorAll(".option[data-color]")
      .forEach((option) => {
        option.addEventListener("click", (event) => this.selectColor(event));
      });
  }

  selectColor(event) {
    this.selectedColor = event.target.getAttribute("data-color");
    this.shadowRoot
      .querySelectorAll(".option[data-color]")
      .forEach((option) => {
        option.classList.remove("selected");
      });
    event.target.classList.add("selected");

    this.checkSelections();
  }

  checkSelections() {
    const selectedVariant = this.productData.variants.find((variant) => {
      return (
        (!this.selectedSize ||
          variant.options[this.sizeIndex] === this.selectedSize) &&
        variant.options[this.colorIndex] === this.selectedColor
      );
    });

    if (selectedVariant) {
      this.addToCart(selectedVariant.id);
    } else {
      console.error("Variant not found for the selected size and/or color.");
    }
  }

  goBack() {
    if (!this.optionsColorContainer.classList.contains("hidden")) {
      this.optionsColorContainer.classList.add("hidden");
      if (this.sizeIndex !== -1) {
        this.optionsSizeContainer.classList.remove("hidden");
        this.updateSelectionText("Size");
      } else {
        this.addToCartBtn.classList.remove("hidden");
        this.selectionText.classList.add("hidden");
        this.backBtn.classList.add("hidden");
      }
    } else if (!this.optionsSizeContainer.classList.contains("hidden")) {
      this.addToCartBtn.classList.remove("hidden");
      this.backBtn.classList.add("hidden");
      this.optionsSizeContainer.classList.add("hidden");
      this.selectionText.classList.add("hidden");
    }
  }

  addToCart(variantId) {
    this.optionsColorContainer.classList.add("hidden");
    this.optionsSizeContainer.classList.add("hidden");
    this.selectionText.classList.add("hidden");
    this.backBtn.classList.add("hidden");
    const form_data = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form_data),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error("Error al agregar el producto al carrito");
        }
      })
      .then((data) => {
        this.plusIconCta.innerHTML = "✔";
        this.plusIconCta.style.background = "green";
        this.plusIconCta.style.color = "white";
        this.plusIconCta.style.transform = "rotate(0deg)";
        // this.addToCartBtn.textContent = 'Added';
        // this.addToCartBtn.classList.remove('hidden'); Remove comment to enable and remove visually hidden class to id="add-to-cart-btn" class="visually-hidden"
        this.backBtn.classList.add("hidden");
        this.updateCartDrawer(true);

        this.enableAddToCart();
      })
      .catch((error) => {
        this.displayStockError();
        this.enablePlusIcon();
        console.error("Error while adding product:", error);
      });
  }

  enablePlusIcon() {
    setTimeout(() => {
      this.plusIconCta.style.background = "white";
      this.plusIconCta.style.color = "black";
      this.plusIconCta.innerHTML = "+";
      this.addToCartBtn.classList.add("hidden");
    }, 700);
  }

  enableAddToCart() {
    setTimeout(() => {
      this.addToCartBtn.textContent = "Add to Cart";
      this.plusIconCta.innerHTML = "+";
      this.plusIconCta.style.background = "white";
      this.plusIconCta.style.color = "black";
    }, 700);
  }

  displayStockError() {
    this.style.opacity = "1";
    this.style.bottom = "0px";
    this.addToCartBtn.classList.remove("visually-hidden");
    this.addToCartBtn.classList.remove("hidden");
    this.addToCartBtn.textContent = "Out of stock";
    this.plusIconCta.style.background = "red";
    this.plusIconCta.style.color = "white";
    this.plusIconCta.innerHTML = "x";
  }

  updateCartDrawer(isProductAdded = false) {
    // Update cart count outisde drawer first
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cartData) => {
        const cartIconBubble = document.querySelector("#cart-icon-bubble");
        const itemCount = cartData.item_count;

        if (!cartIconBubble) {
          const cartIcon = document.createElement("a");
          cartIcon.href = "/cart";
          cartIcon.className =
            "header__icon header__icon--cart link focus-inset";
          cartIcon.id = "cart-icon-bubble";

          cartIcon.innerHTML = `
            ${
              itemCount > 0
                ? '<div class="cart-count-bubble"><span aria-hidden="true">' +
                  itemCount +
                  "</span></div>"
                : ""
            }
            <span class="visually-hidden">Cart</span>
          `;

          document.querySelector("header").appendChild(cartIcon);
        } else {
          const cartCountBubble =
            cartIconBubble.querySelector(".cart-count-bubble");

          if (itemCount > 0) {
            if (cartCountBubble) {
              cartCountBubble.innerHTML = `<span aria-hidden="true">${itemCount}</span>`;
            } else {
              const newCartCountBubble = document.createElement("div");
              newCartCountBubble.className = "cart-count-bubble";
              newCartCountBubble.innerHTML = `<span aria-hidden="true">${itemCount}</span>`;
              cartIconBubble.appendChild(newCartCountBubble);
            }

            const emptyIcon = cartIconBubble.querySelector(".icon-cart-empty");
            if (emptyIcon) {
              emptyIcon.remove();
              const cartIconSVG = `
                <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                  <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"/>
                </svg>
              `;
              cartIconBubble.insertAdjacentHTML("afterbegin", cartIconSVG);
            }
          } else if (cartCountBubble) {
            cartCountBubble.remove();
          }
        }
      })
      .catch((e) => {
        console.error("Error al actualizar el ícono del carrito:", e);
      });

    fetch("/cart?section_id=cart-drawer")
      // Retrieve cart drawer html from shopify
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const newDrawerInner = html.querySelector(".drawer__inner");
        const currentDrawerInner = document.querySelector(".drawer__inner");
        const cartDrawer = document.querySelector("cart-drawer");

        if (currentDrawerInner && newDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;

          if (currentDrawerInner.querySelector(".drawer__inner-empty")) {
            cartDrawer.classList.add("is-empty");
            cartDrawer.classList.remove("active");
          } else {
            cartDrawer.classList.remove("is-empty");
            cartDrawer.classList.add("active");
          }

          if (isProductAdded) {
            cartDrawer.classList.add("is-open");
          }
        }
      })
      .catch((e) => {
        console.error("Error al actualizar el drawer del carrito:", e);
      });
  }
}

customElements.define("quick-add-card", QuickAddCard);
